export default value => {
  if (value) {
    return Array.isArray(value)
      ? value.length
      : value.replace(/\s+/g, '').length;
  }

  return value;
};



// WEBPACK FOOTER //
// ./src/utils/validations/requiredValidator.js